import { createSlice } from "@reduxjs/toolkit";
import { fetchMedications, searchMedications, fetchMedicationById, fetchMedicationsStats } from "../thunks/medicationsDatabaseThunks";

const initialState = {
  medications: [],
  selectedMedication: null,
  searchResults: [],
  stats: null,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
  },
  medicationsLoading: false,
  searchLoading: false,
  statsLoading: false,
  medicationsError: null,
  searchError: null,
};

const medicationsDatabaseSlice = createSlice({
  name: "medicationsDatabase",
  initialState,
  reducers: {
    clearCurrentMedication: (state) => {
      state.selectedMedication = null;
    },
    clearSearchResults: (state) => {
      state.searchResults = [];
    },
    clearError: (state) => {
      state.medicationsError = null;
      state.searchError = null;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedications.pending, (state) => {
        state.medicationsLoading = true;
        state.medicationsError = null;
      })
      .addCase(fetchMedications.fulfilled, (state, action) => {
        state.medicationsLoading = false;
        state.medications =
          action.payload.data || action.payload.medications || [];
        if (action.payload.pagination) {
          state.pagination = action.payload.pagination;
        }
      })
      .addCase(fetchMedications.rejected, (state, action) => {
        state.medicationsLoading = false;
        state.medicationsError = action.payload;
      })
      .addCase(searchMedications.pending, (state) => {
        state.searchLoading = true;
        state.searchError = null;
      })
      .addCase(searchMedications.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.searchResults =
          action.payload.data || action.payload.medications || [];
      })
      .addCase(searchMedications.rejected, (state, action) => {
        state.searchLoading = false;
        state.searchError = action.payload;
      })
      .addCase(fetchMedicationById.pending, (state) => {
        state.medicationsLoading = true;
      })
      .addCase(fetchMedicationById.fulfilled, (state, action) => {
        state.medicationsLoading = false;
        state.selectedMedication = action.payload;
      })
      .addCase(fetchMedicationById.rejected, (state, action) => {
        state.medicationsLoading = false;
        state.medicationsError = action.payload;
      })
      .addCase(fetchMedicationsStats.pending, (state) => {
        state.statsLoading = true;
      })
      .addCase(fetchMedicationsStats.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.stats = action.payload;
      })
      .addCase(fetchMedicationsStats.rejected, (state, action) => {
        state.statsLoading = false;
        state.medicationsError = action.payload;
      });
  },
});

export const { clearCurrentMedication, clearSearchResults, clearError, setPagination } =
  medicationsDatabaseSlice.actions;

export default medicationsDatabaseSlice.reducer;
